/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { Stepper } from '../../themes/koelliker/views/components/stepper.component';
import { IStepperStaticData } from './stepper-static-data.data';
import { IStepperStaticDataProps } from './stepper-static-data.props.autogenerated';
export interface IFinancingStaticDataViewProps extends IStepperStaticDataProps<IStepperStaticData> {}

/**
 *
 * FinancingStaticData component
 * @extends {React.PureComponent<IFinancingStaticDataProps<IFinancingStaticDataData>>}
 */
class StepperStaticData extends React.PureComponent<IStepperStaticDataProps<IStepperStaticData>> {
    public render(): JSX.Element {
        const { config, data } = this.props;
        const salesOrderExtProps = data?.orderHydration?.result?.salesOrder?.ExtensionProperties;
        const salesOrderStatus = salesOrderExtProps
            ? salesOrderExtProps?.filter(i => i.Key === 'SalesOrderStatus_CAP')[0].Value?.StringValue
            : '';
        const StepperProps = {
            config: config,
            salesOrderStatus: Number(salesOrderStatus)
        };
        return <Stepper {...StepperProps} />;
    }
}

export default StepperStaticData;
